<div mat-dialog-container i18n>
  Please match the URL and document contents with the document you have! Are the
  data correct?
</div>
<mat-dialog-actions fxLayout="row" fxLayoutAlign="end end">
  <button mat-button mat-dialog-close color="primary">OK</button>
</mat-dialog-actions>
